export const lessonCategory = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    listLoading: false,
    detail: {},
    detailLoading: false,
    deleteLoading: false,
  },
  getters: {
    list: (state) => {
      return state.list
    },
    detail: (state) => {
      return state.detail
    },
    isListLoading: (state) => {
      return state.listLoading
    },
    isDetailLoading: (state) => {
      return state.detailLoading
    },
    isDeleteLoading: (state) => {
      return state.deleteLoading
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setDetail(state, data) {
      state.detail = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
    setDetailLoading(state, data) {
      state.detailLoading = data
    },
    setDeleteLoading(state, data) {
      state.deleteLoading = data
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/lesson-categories`, {
          params: filters,
          paramsSerializer: (params) => {
            return qs.stringify(params, {
              arrayFormat: 'indices',
              allowDots: true,
              skipNulls: true,
            })
          },
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'lessonCategory/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
    async getDetail({ commit }, id) {
      commit('setDetailLoading', true)
      const response = await axios.get(`/api/lesson-categories/${id}`)
      commit('setDetail', response.data)
      commit('setDetailLoading', false)
    },
    async create({ commit, dispatch }, data) {
      commit('setDetailLoading', true)
      try {
        const response = await axios.post('/api/lesson-categories', data)
        commit('setDetail', response.data)
      } catch (error) {
        dispatch('handleError', error, { root: true })
      } finally {
        commit('setDetailLoading', false)
      }
    },
    async update({ commit, dispatch }, data) {
      commit('setDetailLoading', true)
      try {
        const response = await axios.put(
          `/api/lesson-categories/${data.id}`,
          data
        )
        commit('setDetail', response.data)
      } catch (error) {
        dispatch('handleError', error, { root: true })
      } finally {
        commit('setDetailLoading', false)
      }
    },
    async delete({ commit }, id) {
      commit('setDeleteLoading', true)
      await axios.delete(`/api/lesson-categories/${id}`)
      commit('setDeleteLoading', false)
    },
  },
}
